'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cwUi = require('cw-ui');

var _AutomationName = require('../../../services/AutomationName');

var _AutomationName2 = _interopRequireDefault(_AutomationName);

var _ClickTracker = require('../../../services/ClickTracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @type { React.StatelessComponent } */
var Image = function Image(props) {
  /**
  * Generates automation name
  * @returns {string}
  */
  var getAutomationName = function getAutomationName() {
    return _AutomationName2.default.get('img', props.automationName);
  };

  /**
   * Handles click tracking and fires onClick prop
   */
  var handleClick = function handleClick() {
    (0, _ClickTracker.addClickTrack)(getAutomationName());
    props.onClick();
  };

  return _react2.default.createElement(_cwUi.CwImage, (0, _assign2.default)({}, props, {
    cwId: getAutomationName(),
    onClick: props.onClick ? handleClick : undefined
  }));
};

Image.propTypes = (0, _assign2.default)({
  /**
   * Element id used as selection and search for automation testing
   */
  automationName: _propTypes2.default.string
}, _cwUi.CwImage.propTypes);

exports.default = Image;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/managewidgets/components/image/Image.js
// module id = 146
// module chunks = 10